
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'

import UIkit from 'uikit'

import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacButton,
    BacModal,
    BacLazyImage
  }
})
export default class PictureChooser extends Vue {
  @Prop({ required: true }) pictureName!: string;
  @Prop({ required: true, default: [] }) pictures!: [{id: number; path: string}]
  @Prop({ required: true, default: '' }) bucket!: string
  @Prop({ required: true, default: -1 }) defaultTeamLogoId!: number
  @Prop({ required: false, default: '' }) context!: string

  selectedImageId = -1
  isLoading = false

  mounted () {
    this.selectedImageId = this.defaultTeamLogoId
  }

  @Watch('defaultTeamLogoId')
  onDefaultTeamlogoIdChange () {
    this.selectedImageId = this.defaultTeamLogoId
  }

  saveSelectedPicture () {
    this.$emit('saveSelectedPicture', this.selectedImageId)
    UIkit.modal(`#choose-picture-${this.pictureName.split(' ')[0]}`).hide()
  }

  uploadImage () {
    this.isLoading = true
    const file = ((this.$refs as any).imageUpload as any).files[0]
    const reader = new FileReader()
    reader.addEventListener('load', async (e) => {
      if (!e.target || !e.target.result) {
        throw new Error('Something bad happened trying to load image in FileReader! No Target or Target Result!')
      }
      const base64ImageData = btoa(e.target.result as string)
      const res = await Http.request('/api/minio-ressource', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          bucket: this.bucket,
          name: file.name,
          type: file.type,
          image: base64ImageData,
          context: this.context
        })
      })
      try {
        const resData = await res.json()
        if (res.status === 200) {
          UIkit.notification({
            message: 'Daten gespeichert!',
            status: 'success',
            timeout: 5000,
            pos: 'bottom-center'
          })
          this.$emit('savedNewPicture', resData)
        } else {
          UIkit.notification({
            message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
            status: 'success',
            timeout: 5000,
            pos: 'bottom-center'
          })
          console.error('error saving image, response: ', resData)
        }
      } catch (ex) {
        UIkit.notification({
          message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        console.error('exception saving image, response: ', ex)
      }
    })
    reader.readAsBinaryString(file)
  }
}
